<template>
	<div class="header-page">
		<a class="login-logo" href="#/"><img width="240" class="mt100" src="static/images/logo.png" /></a>
		<!-- <img :src="lang=='my'?'static/images/en.png':'static/images/en1.png'" @click="getLang(1,'')" class="en-my" />
		<div class="en-list" v-if="isEnShow">
			<span :class="{'active':lang=='my'}" @click="getLang(2,'my')">မြန်မာ</span>
			<span :class="{'active':lang=='en'}" @click="getLang(2,'en')">English</span>
		</div> -->
		<Dialog ref="saveDialog" :callback="saveModal" title="Reminder" :cancelText="$t('No')">
        <div slot="mdBox" >
            <div class="">{{$t('des2')}}</div>
        </div>
    </Dialog>
	</div>
</template>

<script>
	import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
		components:{
			Dialog
		},
        data () {
            return {
				search:'',
				isShow:false,
				menus:[
					{url:'/',name:'home'},
					{url:'/GARDENING',name:'GARDENING'},
					{url:'/CIRCUITS',name:'CIRCUITS'},
					{url:'/',name:'COOKING'},
					{url:'/',name:'CRAFT'},
					{url:'/',name:'LIVING'},
					{url:'/',name:'OUTSIDE'},
					{url:'/ebooks',name:'ebooks'},
				],
				isShowMenu:false,
				isShowlogin:false,
				isEnShow:false,
        lang:'en'
            }
        },
    created(){
      if(localStorage.getItem('lang')){
        this.lang = localStorage.getItem('lang')
      }else{
        this.lang = 'en'
      }
    },
		methods: {
			getLang(type,lang){
				if(type==1){
					this.isEnShow = !this.isEnShow
				}else{
					this.isEnShow = false
					localStorage.setItem('lang',lang)
					location.reload()
				}
			},
			showMenu(){
				let that =this;
				this.isShow = false;
				this.isShowMenu = !this.isShowMenu;
			},
			getAcount(){
				let that =this;
				this.isShowMenu = false;
				this.isShow = !this.isShow;
			},
			unSubscribe(){
				this.isShow = false;
				this.$refs.saveDialog.showMaskFun();
			},
			// 弹框保存
			saveModal (){
				this.$refs.saveDialog.closeMask();
			},
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/HeaderLogin.vue